<!--
 * @FileDescription: 横向排列4级区域(省市区县镇)选择框
 * 传入参数 title 选择框标题
 * 传出参数 outAreas 区域ID对象{provId,cityId,distId,townId}
 * @Author: XuYao
 * @Date: 2020-04-27 23:10:02
 * @LastEditors: XuYao
 * @LastEditTime: 2020-04-27 23:10:02
-->
<template>
    <div style="width: 100%;" class="yx-flex-h-start">

        <el-select v-model="provId" clearable @change="provChanged" placeholder="省份" size="small" style="width: 33%;">
            <el-option
                    v-for="item in provs"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>
        <div style="width: 0.5%"/>
        <el-select v-model="cityId" clearable @change="cityChanged" placeholder="城市" size="small" style="width: 33%;">
            <el-option
                    v-for="item in citys"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>
        <div style="width: 0.5%"/>
        <el-select v-model="distId" clearable @change="distChanged" placeholder="区县" size="small" style="width: 33%;">
            <el-option
                    v-for="item in dists"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>

            <!--

                        <el-row :gutter="10">
                <el-col :span="6">

                </el-col>
                <el-col :span="6">
                </el-col>
                <el-col :span="12">
                </el-col>
            </el-row>

            <el-select v-model="townId" clearable @change="townChanged" placeholder="城镇" size="mini" style="display: none;width: 120px; margin-left: 5px">
                <el-option
                        v-for="item in towns"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
-->

    </div>
</template>

<script>
    import {URL_AREAS} from "../../utils/cons";

    export default {
        name: "AreaSelect",
        data() {
            return {
                provs:[],
                citys:[],
                dists:[],
                provId: '',
                cityId: '',
                distId: '',
                provIdName: '',
                cityIdName: '',
                distIdName: '',
                outAreas: {}
            }
        },
        // props 中的对象，从父组件传递来的数据，只有一次操作，就是在 mounted 中接收，往后即使 props 中的对象发生了变化，数据也接收不到。
        // 推荐以下几种方式，根据实际情况选择使用
        // 1、父组件中 使用:key刷新
        // 2、子组件中 直接用计算属性computed获取传入对象
        // 3、子组件中 使用watch监测对象
        props:["inAreas"],
        mounted() {
            // console.log("this.inAreas", this.inAreas)
            if(this.inAreas) {
                this.provId = this.inAreas.provId;
                this.cityId = this.inAreas.cityId;
                this.distId = this.inAreas.distId;
                this.provIdName = this.inAreas.provIdName;
                this.cityIdName = this.inAreas.cityIdName;
                this.distIdName = this.inAreas.distIdName;

                this.provs.push({"id":this.provId,"name":this.provIdName});
                this.citys.push({"id":this.cityId,"name":this.cityIdName});
                this.dists.push({"id":this.distId,"name":this.distIdName});
            }
            this.loadProv();
            this.loadCity();
            this.loadDist();
        },
        methods: {
            emitToParent() {
                this.outAreas = {
                    "provId":this.provId,
                    "cityId":this.cityId,
                    "distId":this.distId
                };
                this.$emit('onAreasChanged', this.outAreas);
                this.$emit('update:outAreas', this.outAreas);
            },
            provChanged() {
                this.citys = [];
                this.dists = [];
                this.cityId = '';
                this.distId = '';
                this.cityIdName = '';
                this.distIdName = '';
                this.emitToParent();
                this.loadCity();
            },
            cityChanged() {
                this.dists = [];
                this.distId = '';
                this.distIdName = '';
                this.emitToParent();
                this.loadDist();
            },
            distChanged() {
                this.emitToParent();
            },
            loadProv() {
                this.getRequest(URL_AREAS).then(resp => { if (resp) this.provs = resp.data });
            },
            loadCity() {
                if(this.provId)
                    this.getRequest(URL_AREAS + '?pid=' + this.provId).then(resp => { if (resp) this.citys = resp.data });
            },
            loadDist() {
                if(this.cityId)
                    this.getRequest(URL_AREAS + '?pid=' + this.cityId).then(resp => { if (resp) this.dists = resp.data });
            }
        }
    }
</script>

<style scoped>

</style>
